import journeysQueries from "../../gql/queries";
import { formatSingleDate } from "../../helpers";
import { fetchFromGraphql } from "entities/helpers/gqlCall";

export const fetchJourneyGroups = async () => {
  const query = journeysQueries.fetchJourneyGroups;
  const queryVars = { journeyGroupType: "DXO", includeInactive: false };
  const { journeyGroups } = await fetchFromGraphql(query, queryVars, "journeyGroups");

  return journeyGroups;
};

export const fetchJourneys = async (journeyGroupId, taskOwnerUserId, taskStatuses, selectedDate) => {
  const query = journeysQueries.fetchJourneys;
  const queryVars = {
    journeyGroupId,
    taskOwnerUserId,
    taskStatuses,
    selectedDate,
  };

  const { journeysForJourneyGroup } = await fetchFromGraphql(query, queryVars, "journeysForJourneyGroup");
  return journeysForJourneyGroup;
};

const fetchTasksForStep = async (userId, stepId, dueDate, statuses) => {
  // PROBABLY NEEDS PERFORMANCE IMPROVEMENT
  const query = journeysQueries.fetchTask;

  const params = {
    journeyTaskId: stepId,
    ownerUserId: userId,
    selectedDate: dueDate,
    statuses,
  };

  const { tasksForJourney } = await fetchFromGraphql(query, params, "tasksForJourney");
  return tasksForJourney.length ? tasksForJourney : [];
};

export const fetchJourneyStepTasks = async (userId, journey, dueDate, statuses) => {
  const steps = journey.steps;
  if (!steps) return [];

  return await Promise.all(
    steps.map(async (step) => {
      const tasks = await fetchTasksForStep(userId, step.id, dueDate, statuses);

      return { ...step, tasks };
    })
  );
};

const isSaturday = (dayDate) => {
  return dayDate.getDay() === 6;
};

const getJourneyCountsForDate = async (selectedJourneyGroupId, taskOwnerUserId, taskStatuses, selectedDate) => {
  const journeysForDate = await fetchJourneys(selectedJourneyGroupId, taskOwnerUserId, taskStatuses, selectedDate);
  const formattedDate = formatSingleDate(selectedDate);
  const dateTotals = { name: formattedDate, email: 0, calls: 0, other: 0, total: 0, completed: 0, date: selectedDate };

  journeysForDate.forEach(({ tasks_due_counts = {} }) => {
    Object.entries(tasks_due_counts).forEach(([key, val]) => {
      if (dateTotals.hasOwnProperty(key)) {
        dateTotals[key] += val;
      }
    });
  });
  return dateTotals;
};

export const fetchJourneysForNextFive = async (selectedJourneyGroupId, taskOwnerUserId, taskStatuses) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayCount = await getJourneyCountsForDate(
    selectedJourneyGroupId,
    taskOwnerUserId,
    taskStatuses,
    today.getTime()
  );
  const counts = [todayCount];
  let date = new Date();
  date.setDate(today.getDate() + 1);
  let startedOnSaturday = isSaturday(today);
  while (counts.length < 5) {
    const journeyCount = await getJourneyCountsForDate(
      selectedJourneyGroupId,
      taskOwnerUserId,
      taskStatuses,
      date.getTime()
    );
    if (isSaturday(date) && !startedOnSaturday) {
      const sundayDate = new Date();
      sundayDate.setHours(0, 0, 0, 0);
      sundayDate.setDate(date.getDate() + 1);
      const sundayCount = await getJourneyCountsForDate(
        selectedJourneyGroupId,
        taskOwnerUserId,
        taskStatuses,
        sundayDate
      );
      if (sundayCount.total > 0 || journeyCount.total > 0) {
        counts.push(journeyCount);
        counts.push(sundayCount);
      }
      date.setDate(date.getDate() + 2);
    } else {
      counts.push(journeyCount);
      date.setDate(date.getDate() + 1);
    }
  }
  return counts.slice(0, 5);
};

export const fetchAllJourneysForAllJourneyGroups = async () => {
  const groups = await fetchJourneyGroups();
  return (await Promise.all(groups.map(async (group) => await fetchJourneysForProfile(group.id)))).flat();
};

const fetchJourneysForProfile = async (journeyGroupId) => {
  const query = journeysQueries.fetchJourneysForProfile;
  const queryVars = { journeyGroupId };
  const { journeysForJourneyGroup } = await fetchFromGraphql(query, queryVars, "journeysForJourneyGroup");

  return journeysForJourneyGroup;
};
